module.exports = __webpack_public_path__ + "img/about-banner-m.63ce87ac.jpg";